import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/line.svg'
  },
  buttonText: 'Chat on Line',
  bubbleBackgroundColor: 'rgba(7, 181, 59, 1)',
  buttonBorderRadius: 24,
  buttonColor: { type: 'native', color: 'rgb(0, 185, 0)' },
  welcomeMessage: 'Hi there 👋 <br><br>How can I help you?',
  bubbleIconColor: 'rgb(255, 255, 255)',
  headerBackgroundColor: 'rgb(132, 158, 191)',
  chatWallpaperMulticolor: { type: 'native', color: 'rgb(255, 255, 255)' },
  messageBackgroundColor: 'rgb(255, 255, 255)',
  align: 'right'
};
